import { lazy } from 'react';

import type { Project } from '@app/api/team';
import { ReactWebComponent } from '@app/utils/web-components';

const PageRoot = lazy(() => import('@app/components/PageRoot'));
const TeamSettingsPage = lazy(() => import('.'));

class TeamSettingsPageComponent extends ReactWebComponent {
    static get observedAttributes() {
        return [
            'keys',
            'keys-in-branches',
            'key-limit',
            'team-projects',
            'project-limit',
            'is-seat-based',
            'contributor',
            'contributor-limit',
            'seats-taken',
            'seats-limit',
            'grace-period-seats',
            'mau',
            'mau-limit',
            'ota-limit',
            'automation-usage',
            'automation-limit',
            'mt-chars-usage',
            'mt-chars-limit',
            'request-count',
            'invited-seats',
            'is-provider-alpha',
            'extra-seats-allowed',
            'project',
            'groups',
            'is-groups-enabled',
            'team-members',
            'show-team-delete-modal',
            'is-ota-enabled',
        ];
    }

    render() {
        const keys = Number(this.prop('keys'));
        const keysInBranches = Number(this.prop('keys-in-branches'));
        const keyLimit = Number(this.prop('key-limit'));
        const projectLimit = Number(this.prop('project-limit'));
        const isSeatBased = this.prop('is-seat-based') === '1';
        const contributors = Number(this.prop('contributors'));
        const contributorLimit = Number(this.prop('contributor-limit'));
        const seatsTaken = Number(this.prop('seats-taken'));
        const seatsLimit = Number(this.prop('seats-limit'));
        const gracePeriodSeats = Number(this.prop('grace-period-seats'));
        const otaLimit = Number(this.prop('ota-limit'));
        const automationUsage = Number(this.prop('automation-usage'));
        const automationLimit = Number(this.prop('automation-limit'));
        const mtCharsUsage = Number(this.prop('mt-chars-usage'));
        const mtCharsLimit = Number(this.prop('mt-chars-limit'));
        const invitedSeats = Number(this.prop('invited-seats'));
        const showTeamDeleteModal = this.prop('show-team-delete-modal') === '1';
        const isExtraSeatsAllowed = this.jsonProp('extra-seats-allowed') === 1;
        const isProviderAlpha = this.jsonProp('is-provider-alpha') === 1;

        const optionalActiveProject = this.getAttribute('project') ?? undefined;
        const activeProject = optionalActiveProject ? (JSON.parse(optionalActiveProject) as Project) : undefined;

        const isGroupsEnabled = this.getAttribute('is-groups-enabled') === 'true';

        const optionalGroupsAttr = this.getAttribute('groups') ?? undefined;
        const groups = optionalGroupsAttr ? (JSON.parse(optionalGroupsAttr) as []) : undefined;

        const optionalTeamMembersAttr = this.getAttribute('team-members') ?? undefined;
        const teamMembers = optionalTeamMembersAttr ? (JSON.parse(optionalTeamMembersAttr) as []) : undefined;

        return (
            <PageRoot>
                <TeamSettingsPage
                    groups={groups}
                    isGroupsEnabled={isGroupsEnabled}
                    activeProject={activeProject}
                    isProviderAlpha={isProviderAlpha}
                    isExtraSeatsAllowed={isExtraSeatsAllowed}
                    invitedSeats={invitedSeats}
                    keys={keys}
                    keysInBranches={keysInBranches}
                    keyLimit={keyLimit}
                    projectLimit={projectLimit}
                    isSeatBased={isSeatBased}
                    contributorsCount={contributors}
                    contributorLimit={contributorLimit}
                    seatsTaken={seatsTaken}
                    seatsLimit={seatsLimit}
                    gracePeriodSeats={gracePeriodSeats}
                    otaLimit={otaLimit}
                    automationUsage={automationUsage}
                    automationLimit={automationLimit}
                    mtCharsUsage={mtCharsUsage}
                    mtCharsLimit={mtCharsLimit}
                    teamMembers={teamMembers}
                    showTeamDeleteModal={showTeamDeleteModal}
                />
            </PageRoot>
        );
    }
}

customElements.define('team-settings-page', TeamSettingsPageComponent);
